import React from 'react';
import AddProductContainer from '../../../Componant/Ecommerce/AddProduct';

const AddProduct = () => {
  return (
    <div className='page-body'>
      <AddProductContainer />
    </div>
  );
};

export default AddProduct;
